
import { Box, Button, Grid, IconButton, Typography } from "@mui/material"
import { icons } from "../../../../../../../../utils/icons"
import { useStyles } from "./styles"
import { DynamicFormRefProps } from "../../../../../../../../components/dynamicFormRef/types"
import { DynamicFormRef } from "../../../../../../../../components/dynamicFormRef"
import { useSectionContext } from "../../contextProvider"
import { typeConfigs } from "../../contextProvider/provider/constants"
import { useTranslation } from "react-i18next"

const QuestionForm = () => {
    const styles = useStyles()
    const { t } = useTranslation()
    const { onChangeQuestionnaire, openConfig, options, optionGroup, refQuestion, isOptionType, option, questionData } = useSectionContext()
    const model = {
        questionText: {
            id: `questionText`,
            label: "Texto de la pregunta",
            name: "questionText",
            type: "text",
            validations: {
                required: { value: true }
            },
            wrapper: (payload) => (
                <Grid
                    item
                    xs={isOptionType.isFree ? 12 : isOptionType.isCatalog ? 7 : 8}
                    children={payload.children}
                    key={payload.id}
                />
            )
        },
        ...!isOptionType.isFree && (
            {
                questionTemplate: {
                    id: `questionTemplate`,
                    label: "Plantillas de respuestas",
                    name: "questionTemplate",
                    type: "selectSimple",
                    items: optionGroup || [],
                    wrapper: (payload) => (
                        <Grid
                            item
                            xs={isOptionType.isCatalog ? 3 : 4}
                            children={(
                                <Box sx={styles.settingContainer}>
                                    <Box sx={{ flex: 1 }}>{payload.children}</Box>

                                    {!isOptionType.isCatalog && <IconButton onClick={settingClick}>{icons('setting')}</IconButton>}
                                </Box>
                            )}
                            key={payload.id}
                        />
                    )
                }
            }
        ),
        ...isOptionType.isCatalog && (
            {
                valueQuestion: {
                    id: `valueQuestion`,
                    label: "Valor",
                    name: "valueQuestion",
                    type: "text",
                    validations: { /* required: { value: true },  */decimal: { value: true }, max: { value: 100 }, min: { value: 0 } },
                    wrapper: (payload) => (
                        <Grid
                            item
                            xs={isOptionType.isCatalog ? 2 : 4}
                            children={(
                                <Box sx={styles.settingContainerCatalog}>
                                    <Box sx={{ flex: 1 }}>{payload.children}</Box>

                                    <IconButton onClick={() => { openConfig({ id: null, name: typeConfigs.answerDataWhitOutReincidence }) }}>{icons('setting')}</IconButton>
                                </Box>
                            )}
                            key={payload.id}
                        />
                    )
                }
            }
        ),
        ...!isOptionType.isCatalog && (
            {
                helpText: {
                    id: `helpText`,
                    label: "Texto de ayuda",
                    name: "helpText",
                    type: 'text',
                    rows: 2,
                    maxRows: 2,
                    multiline: true,
                    wrapper: (payload) => (
                        <Grid
                            item
                            xs={12}
                            children={payload.children}
                            key={payload.id}
                        />
                    )
                },
            }
        )
    } as DynamicFormRefProps['model']

    const settingClick = () => {
        openConfig({ id: null, name: typeConfigs.questionData })
    }


    return (
        <Box sx={styles.container}>
            <Box sx={styles.titleContainer}>
                <Typography sx={styles.title}>{t('Questionarie.newQuestion')}</Typography>

                {/* <IconButton>{icons('fullScreenExit')}</IconButton> */}

                <Box sx={styles.options}>
                    <Typography sx={styles.optionTitle}>{t('Questionarie.answerType')}</Typography>

                    {
                        options?.map(typeOption => (
                            <Button
                                variant={(typeOption.value == option || (!option && typeOption.value == '1')) ? "contained" : "outlined"}
                                key={typeOption.value}
                                onClick={() => {
                                    onChangeQuestionnaire({
                                        "questionOption": typeOption,
                                        "current": "questionOption"
                                    })
                                }}
                            >{typeOption?.label}</Button>
                        ))
                    }
                </Box>
            </Box>

            <DynamicFormRef
                key={questionData?.id as string}
                model={model}
                styleSx={{ width: '100%' }}
                manageDefault={{ selectSimple: true }}
                ref={(element) => refQuestion.addRef({ element, name: 'option' })}
                onChange={(payload) => {
                    if (payload?.current == "questionTemplate" || payload?.current == "valueQuestion") {
                        onChangeQuestionnaire(payload)
                    }
                }}
                onBlur={(payload) => {
                    if (payload?.current != "questionTemplate") {
                        onChangeQuestionnaire(payload)
                    }
                }}
                defaultValues={questionData}
                parentWrapper={({ children }) => <Grid container spacing={3} children={children} />}
            />

            <Typography sx={styles.title}>{t('Questionarie.answers')}</Typography>


        </Box>
    )
}

export { QuestionForm }
